import lightningGreenIcon from '@library/assets/images/icons/lightning-green-icon.svg';
import lightningGreyIcon from '@library/assets/images/icons/lightning-grey-icon.svg';

export interface InGameIndicatorIndicatorProps {
  autoTrade: boolean;
  className?: string;
  inGame: boolean;
}

export const InGameIndicator = ({
  autoTrade,
  className = '',
  inGame
}: InGameIndicatorIndicatorProps) => {
  if (!autoTrade) {
    return null;
  }

  return inGame ? (
    <img alt="In Game Enabled" className={className} src={lightningGreenIcon} />
  ) : (
    <img alt="In Game Disabled" className={className} src={lightningGreyIcon} />
  );
};
